export default __webpack_public_path__ + "static/media/card-1.dda988ba.webp";